
   //export const domain = 'https://localhost:44381/'
   //export const domain = 'http://161.97.97.9:877/'

   // export const domain = 'http://213.136.88.215:44381/'
   export const domain = "https://api.unitedats-tms.com/"
     // export const domain =  "http://207.180.213.97:30301/"
     //export const domain = 'http://161.97.156.231:85/'
   //  export const domain = "http://api.unitedats-tms.com/"

export  const mainSetting = {
     UploadRequestHeader:{'Authorization':'Bearer '+localStorage.getItem("accessToken")},
     FCMToken:""
  }

  export const toolbar = [
   ['bold', 'italic', 'underline', 'link','strike'],        // toggled buttons
  ['blockquote', 'code-block'],

  [{ 'header': 1 }, { 'header': 2 }],               // custom button values
  [{ 'list': 'ordered' }, { 'list': 'bullet' }],
  [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
  [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
  [{ 'direction': 'rtl' }],                         // text direction

  [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

  [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
  [{ 'font': [] }],
  [{ 'align': [] }],
  ['clean'],                                         // remove formatting button
  ['image'],
  ['file'],];
